import { Option } from '~/components/field/common/select';
import { DataType, DataTypeEnum } from '~/models/data-type';
import { FilterModel } from '~/models/filter-model';

/**
 * This should correspond to a subset of the Java enum au.com.finsyn.acuritywebserver.core.utils.paging.filters.FilterFactory.FilterMapping
 * with the addition of NO_FILTER
 */
export enum FilterType {
	STRING_STARTS_WITH = 'STRING_STARTS_WITH',
	STRING_WILDCARD = 'STRING_WILDCARD',
	EQUALS = 'EQUALS',
	NOT_EQUALS = 'NOT_EQUALS',
	GREATER_THAN = 'GREATER_THAN',
	LESS_THAN = 'LESS_THAN',
	EMPTY = 'EMPTY',
	BLANK = 'BLANK', // not used in frontend right now
	IN = 'IN',
	BETWEEN = 'BETWEEN',

	NO_FILTER = 'NO_FILTER',
}

export interface FilterOption extends Option<FilterType> {
	dataTypeNames: DataTypeEnum[];
}

export const filterOptions: FilterOption[] = [
	{
		value: FilterType.STRING_STARTS_WITH,
		displayName: 'filter.option.starts-with',
		dataTypeNames: [DataTypeEnum.String],
	},
	{
		value: FilterType.EQUALS,
		displayName: 'filter.option.equals',
		dataTypeNames: [
			DataTypeEnum.Character,
			DataTypeEnum.BigDecimal,
			DataTypeEnum.Integer,
			DataTypeEnum.Long,
			DataTypeEnum.Currency,
			DataTypeEnum.Percentage,
			DataTypeEnum.String,
		],
	},
	{
		value: FilterType.IN,
		displayName: 'filter.option.is-in',
		dataTypeNames: [DataTypeEnum.String, DataTypeEnum.Character],
	},
	{
		value: FilterType.STRING_WILDCARD,
		displayName: 'filter.option.matches-wildcard',
		dataTypeNames: [DataTypeEnum.String],
	},
	{
		value: FilterType.GREATER_THAN,
		displayName: 'filter.option.is-greater-than',
		dataTypeNames: [
			DataTypeEnum.BigDecimal,
			DataTypeEnum.Integer,
			DataTypeEnum.Long,
			DataTypeEnum.Currency,
			DataTypeEnum.Percentage,
		],
	},
	{
		value: FilterType.LESS_THAN,
		displayName: 'filter.option.is-less-than',
		dataTypeNames: [
			DataTypeEnum.BigDecimal,
			DataTypeEnum.Integer,
			DataTypeEnum.Long,
			DataTypeEnum.Currency,
			DataTypeEnum.Percentage,
		],
	},
	{
		value: FilterType.EQUALS,
		displayName: 'filter.option.is-on',
		dataTypeNames: [DataTypeEnum.Date, DataTypeEnum.Timestamp],
	},
	{
		value: FilterType.LESS_THAN,
		displayName: 'filter.option.is-before',
		dataTypeNames: [DataTypeEnum.Date, DataTypeEnum.Timestamp],
	},
	{
		value: FilterType.GREATER_THAN,
		displayName: 'filter.option.is-after',
		dataTypeNames: [DataTypeEnum.Date, DataTypeEnum.Timestamp],
	},
	{
		value: FilterType.BETWEEN,
		displayName: 'filter.option.is-between',
		dataTypeNames: [
			DataTypeEnum.BigDecimal,
			DataTypeEnum.Integer,
			DataTypeEnum.Long,
			DataTypeEnum.Currency,
			DataTypeEnum.Percentage,
			DataTypeEnum.Date,
			DataTypeEnum.Timestamp,
		],
	},
	{
		value: FilterType.EMPTY,
		displayName: 'filter.option.is-empty',
		dataTypeNames: [
			DataTypeEnum.String,
			DataTypeEnum.Character,
			DataTypeEnum.BigDecimal,
			DataTypeEnum.Integer,
			DataTypeEnum.Long,
			DataTypeEnum.Currency,
			DataTypeEnum.Percentage,
			DataTypeEnum.Date,
			DataTypeEnum.Timestamp,
		],
	},
	{
		value: FilterType.NO_FILTER,
		displayName: 'filter.option.no-filter',
		dataTypeNames: [
			DataTypeEnum.String,
			DataTypeEnum.Character,
			DataTypeEnum.BigDecimal,
			DataTypeEnum.Integer,
			DataTypeEnum.Long,
			DataTypeEnum.Currency,
			DataTypeEnum.Percentage,
			DataTypeEnum.Date,
			DataTypeEnum.Timestamp,
		],
	},
];

export function getFilterOption(filterType: FilterType): FilterOption {
	for (const filterOption of filterOptions) {
		if (filterOption.value === filterType) {
			return filterOption;
		}
	}
	return undefined;
}

export function getFilterOptionsForDataType(
	columnDataType: DataType,
): FilterOption[] {
	return filterOptions.filter((filterOption: FilterOption) => {
		return (
			filterOption.value !== FilterType.NO_FILTER &&
			filterOption.dataTypeNames &&
			columnDataType &&
			filterOption.dataTypeNames.some(
				(name) => name === columnDataType.name,
			)
		);
	});
}
